import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
  limit: 10,
  totalPages: 0,
  totalElements: 0,
};

export const Pagination = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    ChangePage: (state, action) => {
      if (action.payload > 0 && action.payload <= state.totalPages) {
        state.page = action.payload;
      }
    },
    ChangeLimit: (state, action) => {
      if (action.payload > 0) {
        state.limit = action.payload;
        state.page = 1;
      }
    },
    ChangeTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    ChangeTotalElements: (state, action) => {
      state.totalElements = action.payload;
    },
  },
});

export const {
  ChangePage,
  ChangeLimit,
  ChangeTotalPages,
  ChangeTotalElements,
} = Pagination.actions;

export default Pagination.reducer;
